import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { StorageDtoKeyEnum } from '@zaoblako/shared/modules/storage/enums/storage-dto-key.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { entityLikeSchemaUuidStrict } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { StorageFindInterface } from '@zaoblako/shared/modules/storage/dtos/storage/storage-find.dto';

import * as yup from 'yup';

/** S3 storage bucket create and update APIs request body - DTO signature */
export interface BucketFormInterface {
  /** Human-readable bucket name */
  name: string;
  /** Bucket path in S3 storage */
  path: string;
  /** Default bucket flag. Application can have only one default bucket. */
  isDefault?: boolean;
  /** Related storage data */
  storage: StorageFindInterface;
}

/** S3 storage bucket create and update APIs request body - DTO schema */
export const BucketFormDto = SerdeDtoClass.create<BucketFormInterface>(StorageDtoKeyEnum.BUCKET_FORM_DTO, {
  name: {
    sortable: true,
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  path: {
    label: 'Путь',
    serializer: nonEmptyStringSchema,
  },
  isDefault: {
    optional: true,
    label: 'Используется по-умолчанию',
    serializer: yup.boolean(),
  },
  storage: {
    optional: true,
    label: 'Хранилище',
    serializer: entityLikeSchemaUuidStrict,
  },
});
